import React from 'react'
import './Categorias.css';
import { Subcategoria } from './Subcategoria';
import { CategoriaLoading } from './CategoriaLoading';
import { Link, Navigate, Route } from 'react-router-dom';
import { GiFlexibleStar } from 'react-icons/gi';
import * as RiIcons from 'react-icons/ri';
import { cat_fibtexFromServer } from './firebase';

let year = 2019;
function Categorias( props ) {
  console.log(props.user.email)
    //trae las categorias desde el firebase file, 
    //falta configurarlas en el server
    const cat_fibtex = cat_fibtexFromServer; /*[
      {
        id:1, 
        nombre: "Transporte", 
        subcategorias: [
          {id: 2,formula:'distancia_km*peso_ton*591/1000', fe:'591', nombre: "Transporte terrestre",},
          {id: 3,formula_carga:'distancia_km*peso_ton*1.32', formula_nacional:'distancia_km*numero_recorridos*175.3/1000',formula_internacional:'Kilometros*aereo_cantidad_recorridos*110.6/1000', fe_nacional:'175.3', fe_internacional:'110.6', fe_carga:'1.32', nombre: "Transporte aéreo"},
          {id: 4,formula:'distancia_km*peso_ton*6/1000', fe:'6',   nombre: "Transporte marítima"},
           
        ]
      },{
        id:5,
        nombre: "Consumo de energía",
        subcategorias: [
          {id: 6, fe:'0.225', formula:'0.225*consumo_energia_anual_mwh', nombre: "Consumo de energía eléctrica"},
        ] 
      }
    ]*/
    
    const handleYear = (event) =>{
      year = event.target.value;
    }
    const [listCat, setListCat] = React.useState({});
    const [listCatUni, setListCatUni] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [elemAnterior, setElemAnterior] = React.useState('');
    const [isVisibleSubcat, setIsVisibleSubcat] = React.useState('none');
    const [subSel, setSubSel] = React.useState([])

    const [subcategorias, setsubcategorias] = React.useState([]);
    let catUniques = [];

    const [subs, setSubs] = React.useState([]);
    
    //Busca subcategoria dentro de la categoría para mostrar en pantalla
    // y el usuario haga en click para seleccionar
    const buscarSub = (cat) => {
      console.log('buscar subcategoria:: '+cat.fe)
      setIsVisibleSubcat('block');
      const nuevaSubcategorias = [...subcategorias];
      cat.subcategorias.map(subcategoria => {
          nuevaSubcategorias.push(subcategoria);
      });
      setSubs(nuevaSubcategorias);
      
      let elementAnterior = document.getElementById(elemAnterior);
      if (elementAnterior) {console.log('elemente:: '+elementAnterior);elementAnterior.style.background = '';}
      
      let elementNuevo = document.getElementById(cat.id);
      elementNuevo.style.background = '#00C269';
      elementNuevo.style.color = '#FFFFFF';
      setElemAnterior(cat.id);
    };

    // Selecciona y se añade a las subcategorías seleccionadas
    const onClickSub = (sub) => {
      document.getElementById(sub.id).style.background = '#00C269';
      
      var filterSub = subSel.filter(item => item.nombre.includes(sub.nombre));
      filterSub.map(filterS => {
        console.log('FILTER id, nombre:: '+filterS.id+' && '+filterS.nombre);
        document.getElementById(filterS.id).style.background = '#F2F2F2';
      })
      if (filterSub.length > 0){
        const filterSubSels = subSel.filter(element => element.id !== sub.id);
        setSubSel(filterSubSels);
      }else{
        const newSubs = [...subSel];
        //newSubs.push({id:sub.id, nombre:sub.nombre, fe:sub.fe })
        newSubs.push(sub);
        setSubSel(newSubs);
      }     
    }
//{id: 3,formula_carga:'distancia_km*peso_ton*1.32', formula_nacional:'distancia_km*numero_recorridos*175.3/1000',
//formula_internacional:'Kilometros*aereo_cantidad_recorridos*110.6/1000', fe_nacional:'175.3', fe_internacional:'110.6', 
//fe_carga:'1.32', nombre: "Transporte aéreo"},
    const mostrarSubSel = () => {
      subSel.map(subs => {
        console.log(subs.nombre);
      })
    }
    
    if (error) {
        return <div> Error: {error.message }</div> ;
    } else if (isLoading) {
        return <CategoriaLoading />
    } else {
        return (
          <div style={{ padding:'90px 10px' }} className='cardlist__container'>
                <div>
                    <label style={{color: 'dodgerblue'}}>Seleccione el año</label>
                    <select id='selectNombre' style={{ borderRadius:'1.25rem',width:'100px',display:'block',padding:'0.375rem 0.75rem'}}  
                        value={year} 
                        onChange={handleYear}>
                        <option value='2019' >2019</option>
                        <option value='2020' >2020</option>
                    </select>
                </div>
                <h2 className='categoria__titulo'>Seleccione las categorías que apliquen a su empresa.</h2>
                <div className='cardlist-module--sidebar  '>
                  
                    { cat_fibtex.map(cat => (
                      <Subcategoria /*style={{ color: isRed ? 'red' : 'blue' }}*/
                          id={cat.id}
                          key={cat.id}
                          nombre={cat.nombre}
                          onClick={ () => buscarSub(cat)} >
                      </Subcategoria>
                    ))}
                  
                </div>
                <h2 style={{ display:isVisibleSubcat }} className='categoria__titulo'>Seleccione las subcategorías que le apliquen.</h2>
                <div  className='cardlist-module--sidebar'>
                  { subs.map(sub => (
                    /*<Link to="/alcance1" state={{ cat:sub }} key={sub.id} >*/
                      <Subcategoria 
                        id={sub.id}
                        key={sub.id} 
                        nombre={sub.nombre}
                        onClick={ () => onClickSub(sub)} >
                      </Subcategoria>
                    /*</Link>*/
                  )) }
                </div>
                { subSel.length > 0 &&
                  ( <div>
                      <h2>Subcategorías seleccionadas</h2>
                      {subSel.map(subS => (
                        <Subcategoria className='subSeleccionada'
                          key={subS.id} 
                          nombre={subS.nombre}
                          fe={subS.fe}>
                        </Subcategoria>
                      ))}
                      <Link to='/entradas' className='boton__continua' onClick={() => mostrarSubSel()} state={ {subSel} }>CONTINÚA 
                        <RiIcons.RiArrowRightFill/>
                      </Link>
                      
                    </div>
                  )
                }
          </div>
        )
    }
}

export { Categorias, year };
